import { replaceAmpersand, splitAndTrimStr } from '../../../libraries/_helpers';
import {
  statsApiHash,
  cardTypes,
  filterTypes,
  mlsPhaseTypes,
  playerStatsPositionTypes,
  getLanguage
} from '../utils';
import { apiTypes } from './fetching';
import { formatISO } from 'date-fns';
import dayjs from 'dayjs';
import { matchTypes } from '../../mls-match-list/utils';

export const token = window?.forgeVariables?.apiList?.statsAPIToken || null;
export const culture =
  window?.forgeVariables?.currentSite?.culture?.toLowerCase() || 'en-us';
  export const analyticsLocation =
  window?.forgeVariables?.tracking?.pageLocation || ''; 

export const getDefaultCompetitionSportecId = () =>
  window?.forgeVariables?.match?.mlsDefaultCompetitionId || null;

export const composeForgeVariables = () => {
  const { fullGameTags, condensedGameTags, gameHighlightsTags } =
    window?.forgeVariables?.videoTags || {};

  const composedFullGame =
    fullGameTags != null ? splitAndTrimStr(fullGameTags) : null;
  const composedCondensedGame =
    condensedGameTags != null ? splitAndTrimStr(condensedGameTags) : null;
  const composedGameHighlights =
    gameHighlightsTags != null ? splitAndTrimStr(gameHighlightsTags) : null;

  return {
    apiList: {
      statsAPIToken: window?.forgeVariables?.apiList?.statsAPIToken,
      forgeDAPI: window?.forgeVariables?.apiList?.forgeDAPI,
      d3SportsAPI: window?.forgeVariables?.apiList?.d3SportsAPI,
      statsAPI: window?.forgeVariables?.apiList?.statsAPI,
    },
    directoryList: {
      matchHubDir:
        window?.forgeVariables?.directoryList?.matchHubDir || 'competitions',
      playerStatsDir:
        window?.forgeVariables?.directoryList?.playerStatsDir ||
        'stats/players',
      clubStatsDir:
        window?.forgeVariables?.directoryList?.clubStatsDir || 'stats/clubs',
      scheduleDir:
        window?.forgeVariables?.directoryList?.scheduleDir || 'schedule',
      storiesDir: window?.forgeVariables?.directoryList?.storiesDir || 'news',
      visualStoriesDir:
        window?.forgeVariables?.directoryList?.visualStoriesDir ||
        'visual-stories',
    },
    match: window?.forgeVariables?.match,
    urlList: {
      defaultAdUrl: replaceAmpersand(
        window?.forgeVariables?.urlList?.defaultAdUrl
      ),
      venueBgUrl: window?.forgeVariables?.urlList.venueBgUrl,
      baseUrl: window?.forgeVariables?.urlList?.baseUrl || '',
      imageBaseUrl:
        window?.forgeVariables?.urlList?.imageBaseUrl ||
        'https://images.mlssoccer.com',
      ticketMasterPostMatchUrl: replaceAmpersand(
        window?.forgeVariables?.urlList?.ticketMasterPostMatchUrl
      ),
      calendarUrl: window?.forgeVariables?.urlList?.calendarUrl || '',
      remindMeUrl: window?.forgeVariables?.urlList?.remindMeUrl || '',
    },
    videoTags: {
      fullGameTags: composedFullGame,
      condensedGameTags: composedCondensedGame,
      gameHighlightsTags: composedGameHighlights,
    },
    isLeague: forgeVariableToBool(
      window?.forgeVariables?.currentSite?.isLeague
    ),
    isClub: forgeVariableToBool(window?.forgeVariables?.currentSite?.isClub),
    clubOptaId: window?.forgeVariables?.currentSite?.clubOptaId,
    clubSportecId: window?.forgeVariables?.currentSite?.clubSportecId,
    brackets: {
      ThirdPlaceMatchTitle:
        window?.forgeVariables?.brackets?.ThirdPlaceMatchTitle,
    },
    betMgmUrl: window?.forgeVariables?.currentSite?.betMgmUrl,
    freemiumPopupImageUrl:
      window?.forgeVariables?.currentSite?.freemiumPopupImageUrl || '',
  };
};

export const urlList = window?.forgeVariables?.urlList || '';

export const forgeVariableToBool = (forgeVariable) => {
  if (!forgeVariable) {
    return false;
  }

  return forgeVariable?.toLowerCase() === 'true';
};

export const apiURL = {
  statsAPI: window?.forgeVariables?.apiList?.statsAPI
    ? window.forgeVariables.apiList.statsAPI
    : 'https://stats-api.mlsdigital.net/v1',
  forgeDAPI: window?.forgeVariables?.apiList?.forgeDAPI
    ? window.forgeVariables.apiList.forgeDAPI
    : 'https://forge-dapipublic.mls-dev.deltatre.digital/v1',
  d3SportsAPI: window?.forgeVariables?.apiList?.d3SportsAPI
    ? window.forgeVariables.apiList.d3SportsAPI
    : 'https://host-public-sportdataapi.mls-dev.deltatre.digital/api',
  forgeDAPIv1: window?.forgeVariables?.apiList?.forgeDAPIv1
    ? window.forgeVariables.apiList.forgeDAPIv1
    : 'https://forge-dapipublic.mls-dev.deltatre.digital/v1',
  leagueForgeDAPIv1: window?.forgeVariables?.apiList?.leagueForgeDAPIv1
    ? window.forgeVariables.apiList.leagueForgeDAPIv1
    : 'https://forge-dapipublic.mls-dev.deltatre.digital/v1',
};

export const addDays = function (str, days) {
  const date = dayjs(str).toDate();
  date.setDate(date.getDate() + parseInt(days));
  return formatISO(date, { representation: 'date' });
};

export const subDays = function (str, days) {
  const date = dayjs(str).toDate();
  date.setDate(date.getDate() - parseInt(days));
  return formatISO(date, { representation: 'date' });
};

// SportsAPI
export const d3DateRangeAPI = ({
  isoStringRS,
  isoStringRE,
  competitionOptaId = filterTypes.allCompetitions,
  matchType,
  clubOptaId,
  excludeSecondaryTeams = false,
  extendDays = false,
}) => {
  if (!isoStringRS || !isoStringRE) {
    return null;
  }

  const rs = extendDays ? subDays(isoStringRS, 1) : isoStringRS;
  const re = extendDays ? addDays(isoStringRE, 1) : isoStringRE;

  return (
    `matches?` +
    `culture=en-us` +
    `&dateFrom=${rs}` +
    `&dateTo=${re}` +
    `${composeCompetitionOptaIdQueryString(
      competitionOptaId,
      apiTypes.d3SportsAPI
    )}` +
    `${composeMatchType(matchType, competitionOptaId)}` +
    `${!isNaN(clubOptaId) ? '&clubOptaId=' + clubOptaId : ''}` +
    `${excludeSecondaryTeams ? '&excludeSecondaryTeams=true' : ''}`
  );
};

export const d3DateRangeScoreboardAPI = ({
  isoStringRS,
  isoStringRE,
  competitionOptaId = filterTypes.allCompetitions,
  matchType,
  clubOptaId,
  excludeSecondaryTeams = false,
  extendDays = false,
  excludeVenue = false,
  matchDay = null,
  roundNumber = null,
  seasonOptaId = null,
}) => {
  const rs = isoStringRS
    ? extendDays
      ? subDays(isoStringRS, 1)
      : isoStringRS
    : null;
  const re = isoStringRE
    ? extendDays
      ? addDays(isoStringRE, 1)
      : isoStringRE
    : null;

  return (
    `matches?` +
    `culture=en-us` +
    `${rs ? `&dateFrom=${rs}` : ''}` +
    `${re ? `&dateTo=${re}` : ''}` +
    `&excludeVenue=${excludeVenue}` +
    `${matchDay ? `&matchDay=${matchDay}` : ''}` +
    `${roundNumber ? `&roundNumber=${roundNumber}` : ''}` +
    `${composeCompetitionOptaIdQueryString(
      competitionOptaId,
      apiTypes.d3SportsAPI
    )}` +
    `${composeMatchType(matchType, competitionOptaId)}` +
    `${clubOptaId ? '&clubOptaId=' + clubOptaId : ''}` +
    `${seasonOptaId ? '&seasonOptaId=' + seasonOptaId : ''}` +
    `${excludeSecondaryTeams ? '&excludeSecondaryTeams=true' : ''}`
  );
};

export const d3BettingAPI = ({ mgmId, mgmCompetitionId }) => {
  if (!mgmId) {
    return null;
  }

  return (
    `betting/${mgmId}?` +
    `culture=${culture}` +
    (mgmCompetitionId ? `&betMGMcompetitionIds=${mgmCompetitionId}` : '')
  );
};

export const d3ClubsBySportecIdsAPI = ({ clubSportecIds = [] }) => {
  if (!clubSportecIds?.length) {
    return null;
  }

  return `clubs/bySportecIds/${clubSportecIds.join(',')}`;
};

export const d3ClubBySportecIdAPI = ({ clubSportecId }) => {
  if (!clubSportecId) {
    return null;
  }

  return `clubs/bySportecId/${clubSportecId}`;
};

export const d3CompetitionBySportecIdAPI = ({ competitionSportecId }) => {
  if (!competitionSportecId) {
    return null;
  }

  return `competitions/bySportecId/${competitionSportecId}`;
};

export const d3ClubsAPI = ({ competitionOptaId, season }) => {
  if (!competitionOptaId || !season) {
    return null;
  }

  return `clubs/${season}/${competitionOptaId}?culture=en-us`;
};

export const d3StandingsAPI = ({
  competitionSportecId,
  season,
  isLive = false,
}) => {
  if (!season || !competitionSportecId) {
    return null;
  }

  return `standings/live?isLive=${isLive}&${
    season ? `seasonId=${season}` : ''
  }${competitionSportecId ? `&competitionId=${competitionSportecId}` : ''}`;
};

export const d3FormGuideAPI = ({ competitionSportecId, season }) => {
  let matchType = '';
  if (!season && !competitionSportecId) {
    return null;
  }

  return `formguide/${competitionSportecId}/${season}${matchType}`;
};

export const d3FormGuidePageAPI = ({ path, season }) => {
  if (!season && !path) {
    return null;
  }

  return `${path}/${season}`;
};

export const d3MatchesLiteAPI = ({
  year,
  competitionOptaId = filterTypes.allCompetitions,
  clubAbbreviation,
  clubOptaId,
  matchType,
}) => {
  if (!year) {
    return null;
  }

  return (
    `matchesLite/${year}?` +
    `culture=${culture}` +
    `${composeCompetitionOptaIdQueryString(
      competitionOptaId,
      apiTypes.d3SportsAPI
    )}` +
    `${composeClubOptaIdQuery(clubOptaId, apiTypes.d3SportsAPI)}` +
    `${composeClubQuery(clubAbbreviation, apiTypes.d3SportsAPI)}` +
    `${composeMatchType(matchType, competitionOptaId)}`
  );
};

export const d3NextMatchAPI = ({
  startDate,
  competitionOptaId,
  clubOptaId,
  matchType,
}) => {
  return (
    `nextMatches?startDate=${startDate}` +
    `&culture=${culture}` +
    `${composeCompetitionOptaIdQueryString(
      competitionOptaId,
      apiTypes.d3SportsAPI
    )}` +
    `${composeClubOptaIdQuery(clubOptaId, apiTypes.d3SportsAPI)}` +
    `${composeMatchType(matchType, competitionOptaId)}`
  );
};

export const d3MatchesAPI = () => {
  return `matches?culture=en-us`;
};

export const d3SingleMatchAPI = ({ matchSportecId, competitionOptaId }) => {
  if (!matchSportecId) {
    return null;
  }

  return `matches/${matchSportecId}?${
    competitionOptaId ? `competition=${competitionOptaId}` : ''
  }`;
};

export const d3PlayerAPI = ({ matchSportecId }) => {
  if (!matchSportecId) {
    return null;
  }

  return `players/byMatch/${matchSportecId}?culture=${culture}`;
};

export const d3PlayerByIdsAPI = ({ playerIds }) => {
  if (!playerIds?.length) {
    return null;
  }

  const joinedIds = playerIds.join(',');

  return `/players/byPlayerIds/${joinedIds}?culture=${culture}`;
};

export const d3PlayerBySportecIdAPI = ({ sportecId, culture = 'en-us' }) => {
  if (!sportecId) {
    return null;
  }

  return `players/nocache/${sportecId}?culture=${culture}`;
};

export const d3AggregateAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return `aggregate/${matchOptaId}?culture=${culture}`;
};

export const d3BracketsAPI = ({ slug }) => {
  if (!slug) {
    return null;
  }

  return `content/${culture}/brackets/${slug}`;
};

export const d3CompetitionAPI = ({ optaID, matchType }) => {
  if (!optaID) {
    return null;
  }

  return `content/en-us/competitions?fields.optaId=${optaID}&fields.mlsPhaseType=${matchType}`;
};

export const d3PlayersByClubAPI = ({ clubOptaId }) => {
  if (!clubOptaId) {
    return null;
  }

  return `players/byClub/${clubOptaId}?culture=en-us`;
};

export const d3PreviousMatchesAPI = ({
  homeOptaId,
  awayOptaId,
  previousMatchesCount = 3,
  matchDate,
  formGuideMatchesCount = 5,
}) => {
  if (!homeOptaId) {
    return null;
  }

  return `previousMatches/${homeOptaId}?culture=en-us${
    awayOptaId ? `&secondClub=${awayOptaId}` : ''
  }${
    matchDate ? `&matchDate=${matchDate}` : ''
  }&maxItems=${previousMatchesCount}${
    formGuideMatchesCount
      ? `&formGuideMatchesCount=${formGuideMatchesCount}`
      : ''
  }`;
};

export const d3TeamsBySportecIdsAPI = ({ teamSportecIds = [] }) => {
  if (!teamSportecIds?.length) {
    return null;
  }

  return `clubs/bySportecIds/${teamSportecIds.join(',')}`;
};

export const d3MatchesBySportecIdsAPI = ({ matchSportecIds = [] }) => {
  if (!matchSportecIds?.length) {
    return null;
  }

  return `matches/bySportecIds/${matchSportecIds.join(',')}`;
};

// StatsAPI
export const mlsStatisticsAPI = ({
  competitionSportecId,
  seasonSportecId,
  perPage = 100,
}) => {
  if (!competitionSportecId || !seasonSportecId) {
    return null;
  }

  return `statistics/clubs/competitions/${competitionSportecId}/seasons/${seasonSportecId}?per_page=${perPage}`;
};

export const d3PlayerStatsAPI = ({
  competitionSportecId,
  page = 1,
  seasonSportecId,
  sortColumn,
  sortOrder,
  pageSize = 100,
  clubSportecId,
}) => {
  if (!competitionSportecId || !seasonSportecId) {
    return null;
  }

  const params = [
    clubSportecId ? `clubId=${clubSportecId}` : null,
    pageSize ? `pageSize=${pageSize}` : null,
    page ? `page=${page}` : null,
  ].filter(Boolean);

  return `stats/players/competition/${competitionSportecId}/season/${seasonSportecId}/order/${sortColumn}/${sortOrder}?${params.join(
    '&'
  )}`;
};

export const mlsPlayerMatchLogStatsAPI = ({
  route = 'matches',
  playerOptaId,
  pageParam = 0,
  pageSize = 30,
  desc = false,
  orderBy = 'date',
  competition = 'all',
}) => {
  let orderQuery;
  let competitionQuery = '';

  if (orderBy === 'date') {
    orderQuery = 'match_date';
  } else {
    orderQuery = `player_match_stat_${orderBy}`;
  }

  if (competition && competition !== 'all') {
    competitionQuery = `&competition_opta_id=${competition}`;
  }

  if (!playerOptaId) {
    return null;
  }

  return `players/${route}?${composeToken(
    token
  )}&player_opta_id=${playerOptaId}&page=${pageParam}&page_size=${pageSize}&include=competition&include=statistics&include=match&include=club&include=club_match&include=opponent_club&include=opponent_club_match&order_by=${
    desc ? '-' : ''
  }${orderQuery}${competitionQuery}`;
};

export const mlsPlayerMatchLogStatsAPIv2 = ({
  playerId,
  competitionId,
  page_token,
}) => {
  const url = `statistics/players/${playerId}/matches`;
  const searchParams = new URLSearchParams();

  if (competitionId && competitionId !== 'all') {
    searchParams.set('competition_id', competitionId);
  }
  if (page_token) {
    searchParams.set('page_token', page_token);
  }
  if (searchParams.toString()) {
    return `${url}?${searchParams.toString()}`;
  }
  return url;
};

export const mlsGetMatches = ({
  seasonSportecId,
  from,
  to,
  competitionSportecId,
  clubSportecId,
  sort,
  perPage = 100,
  seriesName
}) => {
  if (!seasonSportecId) {
    return null;
  }

  let params = [
    from ? `match_date[gte]=${from}` : null,
    to ? `match_date[lte]=${to}` : null,
    competitionSportecId ? `competition_id=${competitionSportecId}` : null,
    clubSportecId ? `team_id=${clubSportecId}` : null,
    perPage ? `per_page=${perPage}` : null,
    sort ? `sort=${sort}` : null,
    seriesName ? `series_name=${seriesName}` : null,
  ].filter(Boolean);

  return `matches/seasons/${seasonSportecId}?${params.join('&')}`;
};

export const mlsCompetitionsAPI = () => {
  return `competitions`;
};

export const mlsSeasonsAPI = ({ competitionSportecId }) => {
  if (!competitionSportecId) {
    return null;
  }

  return `competitions/${competitionSportecId}/seasons`;
};

export const mlsStandingsAPI = ({
  competitionSportecId,
  seasonSportecId,
  category,
  type,
  isLive,
}) => {
  if (!competitionSportecId || !seasonSportecId) {
    return null;
  }

  const filters = [
    category ? `category=${category}` : null,
    type ? `type=${type}` : null,
    isLive ? `is_live=${isLive}` : null,
  ].filter(Boolean);

  return `competitions/${competitionSportecId}/seasons/${seasonSportecId}/standings?${filters.join(
    '&'
  )}`;
};

export const mlsStatsComparisonAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `clubs/matches?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=club&include=match&include=competition&include=statistics`
  );
};

export const mlsStatsStandingsAPI = ({
  seasonSportecId,
  competitionSportecId,
  clubSportecIds = [],
}) => {
  if (!seasonSportecId && !competitionSportecId) {
    return null;
  }

  return (
    `standings?` +
    `${composeToken(token)}` +
    `${composeSeasonQueryString(seasonSportecId)}` +
    `${composeCompetitionOptaIdQueryString(competitionSportecId)}` +
    `${composeMultipleClubOptaIdQuery(clubSportecIds)}` +
    '&include=club'
  );
};

export const mlsClubMatchAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `clubs/matches?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}`
  );
};

export const mlsClubMatchPossessionAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `clubs/matches/possessions?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}`
  );
};

export const mlsSeasonStatsComparisonAPI = ({
  homeOptaId,
  awayOptaId,
  season,
  competitionOptaId,
}) => {
  if (!homeOptaId || !awayOptaId || !season || !competitionOptaId) {
    return null;
  }

  return (
    `clubs/seasons?` +
    `${composeToken(token)}` +
    `&include=club&include=statistics&club_opta_id=${homeOptaId}` +
    `&club_opta_id=${awayOptaId}` +
    `&season_opta_id=${season}` +
    `&competition_opta_id=${competitionOptaId}`
  );
};

export const mlsPossessionIntervalsAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `matches/possessions?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&match_possession_duration=5&match_possession_category=Territorial&match_possession_type=IntervalLengths`
  );
};

export const mlsPossessionOverallAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `matches/possessions?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&match_possession_category=Territorial&match_possession_type=Overall`
  );
};

export const mlsMatchOfficialsAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `officials/matches?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=official`
  );
};


export const mlsMatchCommentariesAPI = ({
  matchSportecId,
  page_token,
  perPage = 25,
}) => {
  if (!matchSportecId) {
    return null;
  }

  const language = getLanguage();

  return `matches/${matchSportecId}/commentary?${
    page_token ? `page_token=${page_token}&` : ''
  }language=${language}`;
};

/**
 * [Description of your function]
 *
 * @param {string} matchSportecId - The sportec ID of the match
 * @param {string} pageSize - The number of key events to fetch
 * @returns {string} - The endpoint to fetch the key events
 */
export const mlsMatchKeyEventsAPI = ({ matchSportecId, pageSize }) => {
  if (!matchSportecId) {
    return null;
  }

  return `matches/${matchSportecId}/key_events${
    pageSize ? `?per_page=${pageSize}` : ''
  }`;
};

export const mlsPenaltyKicksAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `penaltykicks?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=club&include=player&order_by=match_opta_id`
  );
};

export const mlsBookingsAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `bookings?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=player`
  );
};

export const mlsPlayersMatchAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `players/matches?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=player&include=club`
  );
};

export const mlsPlayerAPI = ({ playerOptaId }) => {
  if (!playerOptaId) {
    return null;
  }

  return `players/${playerOptaId}`;
};

export const mlsSubstitutionsAPI = ({ matchSportecId, eventType }) => {
  if (!matchSportecId) {
    return null;
  }

  return `matches/${matchSportecId}/key_events${
    eventType ? `?event=${eventType}` : ''
  }`;
};

export const mlsManagersAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `managers/matches?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&include=manager&include=club`
  );
};

export const mlsNeedToKnowAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `matchfacts?` +
    `${composeToken(token)}` +
    `&matchfact_language=en` +
    `${composeMatchOptaId(matchOptaId)}`
  );
};

export const mlsSingleMatchStatsAPI = ({ matchSportecId }) => {
  if (!matchSportecId) {
    return null;
  }

  return `/matches/${matchSportecId}`;
};

export const mlsMatchesStatsAPI = ({ matchesOptaIds }) => {
  if (!matchesOptaIds) {
    return null;
  }

  return (
    `matches?` +
    `${composeToken(token)}` +
    `${composeMatchesOptaIds(matchesOptaIds)}` +
    `&include=away_club_match&include=home_club_match&include=venue&include=home_club&include=away_club`
  );
};

export const mlsClubsAPI = ({ competitionSportecId, seasonSportecId }) => {
  if (!competitionSportecId || !seasonSportecId) {
    return null;
  }
  return `clubs/competitions/${competitionSportecId}/seasons/${seasonSportecId}?per_page=100`;
};

export const mlsGoalsAPI = ({
  matchOptaId,
  includeClub = true,
  includePlayer = false,
  includeAssists = false,
}) => {
  if (!matchOptaId) {
    return null;
  }

  return (
    `goals?` +
    `${composeToken(token)}` +
    `${composeMatchOptaId(matchOptaId)}` +
    `&order_by=goal_minute${includeClub ? '&include=club' : ''}` +
    `${includePlayer ? '&include=player' : ''}` +
    `${
      includeAssists
        ? '&include=first_assist_player&include=second_assist_player'
        : ''
    }`
  );
};

export const mlsPlayerCareerStatsAPI = ({
  route = 'seasons',
  filterType,
  playerOptaId,
  desc = false,
  competitionId = '98',
  orderBy = 'date',
}) => {
  if (!playerOptaId || !filterType) {
    return null;
  }

  let orderQuery;

  if (orderBy === 'date') {
    orderQuery = 'season_opta_id';
  } else {
    orderQuery = `player_season_stat_${orderBy}`;
  }

  switch (filterType) {
    case 'MLS Regular Season':
      return `players/${route}?${composeToken(
        token
      )}&player_opta_id=${playerOptaId}&include=season&include=regular_season_statistics&include=club&competition_opta_id=98&order_by=${
        desc ? '-' : ''
      }${orderBy === 'date' ? orderQuery : 'regular_season_' + orderQuery}`;
    case 'MLS Post Season':
      return `players/${route}?${composeToken(
        token
      )}&player_opta_id=${playerOptaId}&include=season&include=postseason_statistics&include=club&competition_opta_id=98&order_by=${
        desc ? '-' : ''
      }${orderBy === 'date' ? orderQuery : 'postseason_' + orderQuery}`;
    case 'Custom Competition':
      return `players/${route}?${composeToken(
        token
      )}&player_opta_id=${playerOptaId}&include=season&include=statistics&include=club&competition_opta_id=${competitionId}&order_by=${
        desc ? '-' : ''
      }${orderQuery}`;
    default:
      return null;
  }
};

export const mlsClubStatsAPI = ({ competitionSportecId, seasonSportecId }) => {
  if (!competitionSportecId || !seasonSportecId) {
    return null;
  }

  return `statistics/clubs/competitions/${competitionSportecId}/seasons/${seasonSportecId}?per_page=50`;
};

// Forge DAPI
export const dapiMatchAPI = ({ matchSlug }) => {
  if (!matchSlug) {
    return null;
  }

  return `content/en-us/matches/${matchSlug}`;
};

export const dapiClubPlayersAPI = ({
  clubSportecId,
  culture = 'en-us',
  perPage = 100,
}) => {
  if (!clubSportecId) {
    return null;
  }

  return `content/${culture}/players?fields.clubSportecId=${clubSportecId}&fields.isActiveMLSPlayer=true&$skip=0&$limit=${perPage}`;
};

export const dapiSeasonAPI = ({
  competitionSportecId,
  sportecId,
  culture = 'en-us',
}) => {
  if (!competitionSportecId || !sportecId) {
    return null;
  }

  return `content/${culture}/seasons?fields.competitionSportecId=${competitionSportecId}&fields.sportecId=${sportecId}`;
};

export const dapiSeasonContentAPI = ({ slug, culture = 'en-us' }) => {
  if (!slug) {
    return null;
  }

  return `content/${culture}/seasons/${slug}`;
};

export const forgeEditorialSelectionAPI = ({ slug }) => {
  if (slug == null) {
    return null;
  }

  return `content/${culture}/sel-${slug}`;
};

export const forgeMatchVideosAPI = ({ matchSportecId }) => {
  if (!matchSportecId) {
    return null;
  }

  return `content/${culture}/brightcovevideos?fields.sportecMatchId=${matchSportecId}`;
};

export const forgeMatchContentVideosAPI = ({ matchSlug }) => {
  if (!matchSlug) {
    return null;
  }

  return `content/${culture}/brightcovevideos?tags.slug=${matchSlug}`;
};

export const forgeVisualStoriesAPI = ({ matchSlug }) => {
  if (!matchSlug) {
    return null;
  }

  return `content/${culture}/visualstories?tags.slug=${matchSlug}`;
};

export const forgeMatchStoriesAPI = ({ matchSlug }) => {
  if (!matchSlug) {
    return null;
  }

  return `content/${culture}/stories?tags.slug=${matchSlug}`;
};

export const forgeMatchRelatedVideosAPI = ({ matchOptaId }) => {
  if (!matchOptaId) {
    return null;
  }

  return `relatedVideos/${matchOptaId}?culture=${culture}`;
};

export const forgeSeasonAPI = ({ seasonOptaId }) =>
  `content/${culture}/seasons?fields.optaId=${seasonOptaId}`;

export const forgeSeasonAPILeague = ({ seasonOptaId }) =>
  `content/en-us/seasons?fields.optaId=${seasonOptaId}`;

export const forgePlayerDAPI = ({ sportecId }) => {
  if (!sportecId) {
    return null;
  }

  return `content/en-us/players?fields.sportecId=${sportecId}`;
};

export const forgeMlsCompetitionClubsDAPI = ()=>{
  return 'content/en-us/clubs?fields.isLeaguesCupMLSClub=true&$limit=100'
}

export const forgeClubDAPI = ({ optaId }) => {
  if (!optaId) {
    return null;
  }

  return `content/en-us/clubs?fields.optaId=${optaId}`;
};

export const forgeSuperDraftAPI = ({ superDraftSlug }) =>
  `content/${culture}/superdraft/${superDraftSlug}`;

export const forgeSuperDraftPicksAPI = ({ superDraftSlugTag }) => {
  if (!superDraftSlugTag) return '';
  return `content/${culture}/superdraftpicks?tags.slug=${superDraftSlugTag}&$limit=100`;
};

//URL composing functions
function composeSeasonQueryString(season) {
  return season ? `&season_opta_id=${season}` : '';
}

function composeCompetitionOptaIdQueryString(
  competitionOptaId,
  apiType = apiTypes.statsAPI
) {
  return competitionOptaId && competitionOptaId !== filterTypes.allCompetitions
    ? `&${
        apiType === apiTypes.statsAPI ? 'competition_opta_id' : 'competition'
      }=${competitionOptaId}`
    : '';
}

function composeOrderByQueryString(
  statType,
  route = 'seasons',
  desc,
  mlsPhaseType,
  type = 'player',
  allYears = false
) {
  const phasePrefix =
    mlsPhaseType === mlsPhaseTypes.regular
      ? `regular_season_`
      : mlsPhaseType === mlsPhaseTypes.cup
      ? `postseason_`
      : '';

  return statType
    ? allYears
      ? `&order_by=${desc ? '-' : ''}${phasePrefix}${type}_stat_${statType}`
      : `&order_by=${desc ? '-' : ''}${phasePrefix}${type}_${
          route === 'seasons' ? 'season' : 'match'
        }_stat_${statType}`
    : '';
}

function composeAppearancesQueryString(appearances, route) {
  return appearances && appearances !== filterTypes.all && route === 'seasons'
    ? `&player_season_stat_appearances[$eq]=${appearances}`
    : '';
}

function composePageQueryString(page) {
  return page ? `&page=${page}` : '';
}

function composePageSizeQueryString(pageSize) {
  return pageSize != null ? `&page_size=${pageSize}` : '';
}

function composePositionQuery(position, route) {
  if (!position || (position && position === filterTypes.all)) {
    return '';
  }

  if (position.toUpperCase() === 'OUTFIELD PLAYERS') {
    return `&player_${
      route === 'seasons' ? 'season_position_generic' : 'match_position'
    }[$ne]=Goalkeeper`;
  }

  return `&player_${
    route === 'seasons' ? 'season_position_generic' : 'match_position'
  }=${position}`;
}

function composeClubQuery(club, apiType = apiTypes.statsAPI) {
  return club != null && club !== filterTypes.allClubs
    ? `&${
        apiType === apiTypes.statsAPI ? 'club_abbreviation' : 'clubAbbreviation'
      }=${club}`
    : '';
}

function composeClubOptaIdQuery(clubOptaId, apiType = apiTypes.statsAPI) {
  return clubOptaId != null && clubOptaId !== filterTypes.allClubs
    ? `&${
        apiType === apiTypes.statsAPI ? 'club_opta_id' : 'clubOptaId'
      }=${clubOptaId}`
    : '';
}

function composeMultipleClubOptaIdQuery(clubOptaIds) {
  if (!clubOptaIds?.length) {
    return '';
  }

  return clubOptaIds
    .map((clubOptaId, i) => `&club_opta_id=${clubOptaId}`)
    .join('');
}

function composeRestOfCommentaries(includeRest) {
  return includeRest
    ? '&commentary_type=lineup&commentary_type=start&commentary_type=end%201&commentary_type=end%202&commentary_type=end%203&commentary_type=end%204&commentary_type=end%205&commentary_type=end%2014&commentary_type=start%20delay&commentary_type=end%20delay&commentary_type=postponed&commentary_type=free%20kick%20lost&commentary_type=free%20kick%20won&commentary_type=attempt%20blocked&commentary_type=attempt%20saved&commentary_type=miss&commentary_type=post&commentary_type=corner&commentary_type=offside&commentary_type=penalty%20won&commentary_type=penalty%20lost&commentary_type=penalty%20miss&commentary_type=penalty%20saved&commentary_type=player%20retired&commentary_type=contentious%20referee%20decisions&commentary_type=VAR%20cancelled%20goal'
    : '';
}

function composePhaseType(phase, competitionOptaId) {
  switch (phase) {
    case mlsPhaseTypes.regular:
      return `&include=regular_season_statistics`;
    case mlsPhaseTypes.cup:
      return `&include=postseason_statistics`;
    default:
      return `&include=statistics`;
  }
}

function composeRoute(route) {
  return route === 'matches' ? '&include=match' : '';
}

function composeMatchOptaId(matchOptaId) {
  return matchOptaId ? `&match_game_id=${matchOptaId}` : '';
}

function composeMatchesOptaIds(matchesOptaIds) {
  return matchesOptaIds?.length
    ? matchesOptaIds?.map((optaId) => '&match_game_id=' + optaId)?.join('')
    : '';
}

function composeMatchType(matchType, competitionOptaId = '98') {
  return competitionOptaId !== '98' || matchType == null
    ? ''
    : `&matchType=${matchType}`;
}

function composeToken(statsAPIToken) {
  return statsAPIToken ? `token=${statsAPIToken}` : '';
}
